import {
    AfterContentInit,
    Component,
    ContentChildren,
    Input,
    OnDestroy,
    OnInit,
    QueryList,
} from "@angular/core"
import { AccordionItemDirective } from "./accordion-item.directive"
import { AccordionService, AccordionState } from "./accordion.service"

@Component({
    selector: "app-accordion",
    templateUrl: "./accordion.component.html",
    styleUrls: ["./accordion.component.scss"],
    standalone: false,
})
export class AccordionComponent implements OnInit, AfterContentInit, OnDestroy {
    @Input()
    instanceId: string

    @Input()
    accordionTitle: string

    @Input()
    public isExpanded = false

    @Input()
    public itemsToShow = 4

    @ContentChildren(AccordionItemDirective)
    public items: QueryList<AccordionItemDirective>

    public allItemsVisible = false
    public isShowAllButtonVisible: boolean

    constructor(private accordionService: AccordionService) {}

    public ngOnInit() {
        this.stateObserver = this.stateObserver.bind(this)
        this.accordionService.register(this.instanceId, this.stateObserver)
        this.resolveAccordionState()
    }

    public ngAfterContentInit() {
        this.isShowAllButtonVisible =
            this.items.filter((i) => i.includeInCount).length > this.itemsToShow
        this.resetItemDisplay()
    }

    public ngOnDestroy() {
        this.accordionService.deregister(this.instanceId, this.stateObserver)
    }

    public toggleExpansion() {
        this.isExpanded = !this.isExpanded
        this.accordionService.setState(this.instanceId, this.accordionState)
    }

    public toggleShowMore() {
        this.allItemsVisible = !this.allItemsVisible
        this.resetItemDisplay()
        this.accordionService.setState(this.instanceId, this.accordionState)
    }

    public stateObserver(state: AccordionState) {
        this.isExpanded = state.isExpanded
        this.allItemsVisible = state.allItemsVisible
        this.resetItemDisplay()
    }

    private get accordionState(): AccordionState {
        return {
            isExpanded: this.isExpanded,
            allItemsVisible: this.allItemsVisible,
        }
    }

    private set accordionState(state: AccordionState) {
        this.isExpanded = state.isExpanded
        this.allItemsVisible = state.allItemsVisible
    }

    private resetItemDisplay() {
        let count = 0
        this.items.forEach((item, index) => {
            if (count === this.itemsToShow && !this.allItemsVisible) {
                item.hide()
                return
            }
            item.show()

            if (item.includeInCount) {
                count += 1
            }
        })
    }

    private resolveAccordionState() {
        const savedAccordionState = this.accordionService.getState(this.instanceId)

        if (savedAccordionState) {
            this.accordionState = savedAccordionState
        } else {
            this.accordionService.setState(this.instanceId, this.accordionState, false)
        }
    }
}
